'use client'
import type { Data } from '@repo/strapi'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { BlogCard } from '@/app/[locale]/blog/_components/BlogCard'
import { Button } from '@/components/ui/button'
import { RELATED_ARTICLES_TEST_IDS } from '@/lib/test-ids'

export function RelatedArticlesContent({
	articles,
	showLink = false,
}: {
	articles?: Data.ContentType<'api::blog-article.blog-article'>[] | null
	showLink?: boolean | null
}) {
	const t = useTranslations('RelatedArticlesContent')
	const [showMore, setShowMore] = useState(false)

	return (
		articles &&
		articles?.length > 0 && (
			<>
				<div
					className="grid gap-y-6 md:gap-x-8 lg:gap-y-15 md:grid-cols-2 lg:grid-cols-3"
					data-test-id={RELATED_ARTICLES_TEST_IDS.LIST}
				>
					{articles?.slice(0, showMore ? articles?.length : 3)?.map((article) => (
						<BlogCard key={article.id} article={article} showLink={showLink} titleTag="h3" />
					))}
				</div>
				{articles?.length > 3 && (
					<div className="flex w-full justify-center items-baseline">
						<Button
							variant="primary"
							size="large"
							onClick={() => setShowMore(!showMore)}
							data-test-id={RELATED_ARTICLES_TEST_IDS.SHOW_MORE}
						>
							{showMore ? t('showLess') : t('showMore')}
						</Button>
					</div>
				)}
			</>
		)
	)
}
